import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import { apiEditMemberPoolStorage } from '../../api/MemberPoolStorageAPI';
import { MEMBER_POOL_STORAGE_EDIT_REQUEST } from '../actions/types/MemberPoolStorageEditActionsTypes';
import { putMemberPoolStorageEditSuccessActionCreator, putMemberPoolStorageEditFailureActionCreator } from '../actions/MemberPoolStorageEditActions';
import { languageSelector } from '../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../locales/locales';

function* doMemberPoolStorageEditWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiEditMemberPoolStorage, action.payload);
    yield put(putMemberPoolStorageEditSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: <FormattedMessage
        id="notification.member-pool-storage.edit.success"
        values={{ transactionProcessingFrequency: process.env.transactionProcessingFrequency }}
      />,
    }));
  } catch (error) {
    yield put(putMemberPoolStorageEditFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'app.server.error'),
    }));
  }
}

function* doMemberPoolStorageEditWatcher() {
  yield takeLatest(MEMBER_POOL_STORAGE_EDIT_REQUEST, doMemberPoolStorageEditWorker);
}

export default doMemberPoolStorageEditWatcher;
